/**
 * @generated SignedSource<<54d008e4f58d0a01883507fd42b6504b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesEditorCateringSettings_package$data = {
  readonly cateringOptions: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly id: string;
  readonly " $fragmentType": "RoomRatesEditorCateringSettings_package";
};
export type RoomRatesEditorCateringSettings_package$key = {
  readonly " $data"?: RoomRatesEditorCateringSettings_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesEditorCateringSettings_package">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesEditorCateringSettings_package",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "CateringOption",
      "kind": "LinkedField",
      "name": "cateringOptions",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Package",
  "abstractKey": null
};
})();

(node as any).hash = "5a2e4766a19bd1fa2ab833bb6248c571";

export default node;
